import React, { Component } from 'react'
import { DatePicker, TimePicker, Switch, InputNumber, Checkbox, Menu, Dropdown, Icon, Button, message, Select } from 'antd'
import { inject, observer } from "mobx-react"
import { makeEvent as makeContractEvent } from '../../../contract/Events'
import { makeEvent as makeApiEvent } from '../../../api-calls/events'
import ContractStore from '../../../stores/ContractStore'
import EventStore from '../../../stores/EventStore'
import Color from 'color'
//import UserStore from '../../../stores/UserStore';
const Option = Select.Option;
@observer(["web3Store", "AuthStore", "TeamStore", "CategoriesStore", "AdminStore", "ViewStore", "UserStore", "LeagueStore"])
@observer class MakeEvent extends Component {
    constructor(props) {
        super(props);
        this.onTeamClick = this.onTeamClick.bind(this);
        this.onTeamOneClick = this.onTeamOneClick.bind(this);
        this.onTeamTwoClick = this.onTeamTwoClick.bind(this);
        this.onDurationChange = this.onDurationChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.onDrawPossibleChange = this.onDrawPossibleChange.bind(this);
        this.onFormChange = this.onFormChange.bind(this);
        this.onCategoryClick = this.onCategoryClick.bind(this);
        this.onClick = this.onClick.bind(this);
        this.renderLeagueMenu = this.renderLeagueMenu.bind(this);
        this.onLeagueClick = this.onLeagueClick.bind(this);
        this.renderTeamSelect = this.renderTeamSelect.bind(this);
        this.handleTeamsChange = this.handleTeamsChange.bind(this);
        this.handleAddTeam = this.handleAddTeam.bind(this);
        this.handleRemoveTeam = this.handleRemoveTeam.bind(this);
        this.state = {
            activeEventsArray: [],
            eSports: false,
            teams: [],
            categories: [],
            teamOneId: "",
            teamTwoId: "",
            teamOneBytes32Id: "",
            teamTwoBytes32Id: "",
            drawBytesId: "0x6472617700000000000000000000000000",
            teamOneName: "Team One Name",
            teamTwoName: "Team Two Name",
            teamOneLogoUrl: "https://cdn2.iconfinder.com/data/icons/bold-ui/100/questionmark-512.png",
            teamTwoLogoUrl: "https://cdn2.iconfinder.com/data/icons/bold-ui/100/questionmark-512.png",
            chosenDuration: 0,
            categoryName: "no category chosen",
            leagues: [],
            leagueName: "No league chosen",
            teamOneColors: [],
            teamTwoColors: [],
            teamsChosen: [{ team: '' }, { team: '' }],

            drawPossible: false,
            makerBond: 10000,
            officialStart: new Date().getTime() / 1000
        };
    }

    async componentWillMount() {
        const { TeamStore, CategoriesStore, AdminStore, LeagueStore } = this.props;
        let self = this;
        let oraclePeriod;
        AdminStore.getOraclePeriod().then((response) => {
            self.setState({ oraclePeriod: response });
        });

        let teamList = [];
        TeamStore.queryTeams().then(async () => {
            setTimeout(() => {
                this.setState({ teams: Array.from(TeamStore.teams.values()) });
            }, 500)

        });

        let categoryList = [];
        CategoriesStore.queryCategories().then(async () => {
            setTimeout(() => {
                this.setState({ categories: Array.from(CategoriesStore.categories.values()) });
            }, 500)

        });

        let leagueList = [];
        LeagueStore.queryLeagues().then(async () => {
            setTimeout(() => {
                this.setState({ leagues: Array.from(LeagueStore.leagues.values()) });
            }, 500)

        })



        window.makeEvent = async () => {
            const { web3Store } = this.props;
        };
    }

    onClick() {
        const { web3Store, eventStore, contractStore, AuthStore, TeamStore, UserStore } = this.props;
        if (this.state.categoryName == "no category chosen") {
            return message.warning("Must select a category!");
        }
        if (this.state.chosenDuration <= 0) {
            return message.warning("Duration must be greater than 0!");
        }
        const authToken = AuthStore.userAuth.auth.accessToken;
        const eventBytes32Id = web3Store.web3.utils.sha3(this.state.teamOneName + this.state.teamTwoName + (+Date.now()));
        console.log(eventBytes32Id)
        const duration = this.state.chosenDuration;
        const makerBond = this.state.makerBond;
        const startTime = this.state.officialStart;//+Date.now() / 1000;
        const drawPossible = this.state.drawPossible;
        const categoryId = this.state.category;
        const leagueId = this.state.leagueId;
        let contractTeams = [];
        let apiTeams = [];
        this.state.teamsChosen.forEach(team => {
            contractTeams.push(team.bytes32Id);
            apiTeams.push(team._id);
        });


        if (drawPossible) {
            contractTeams.push(this.state.drawBytesId);
        }
        // const apiTeams = [this.state.teamOneId, this.state.teamTwoId];
        let contrast = 0;
        let newContrast = 0;
        let teamColorsPicked = [];
        let teamOneColorPicked;
        let teamTwoColorPicked;

        // if (this.state.teamOneColors.length > 0 && this.state.teamTwoColors.length > 0) {
        //     teamOneColorPicked = this.state.teamOneColors[0];
        //     let teamOneColorObject = Color(teamOneColorPicked);
        //     let teamTwoColorObject;

        //     for (let color = 0; color < this.state.teamTwoColors.length; color++) {
        //         teamTwoColorObject = Color(this.state.teamTwoColors[color]);
        //         newContrast = Math.abs(teamOneColorObject.rgb().array()[0] - teamTwoColorObject.rgb().array()[0]);
        //         console.log("contrast between " + teamOneColorPicked + " and " + this.state.teamTwoColors[color] + " is " + newContrast);
        //         if (newContrast > contrast) {
        //             contrast = newContrast;
        //             teamTwoColorPicked = this.state.teamTwoColors[color];
        //         }

        //     }

        //     console.log(teamOneColorPicked + " and " + teamTwoColorPicked + " were chosen as they provide the highest possible contrast of " + contrast);

        // }

        if (this.state.teamsChosen.length > 1) {
            // teamOneColorPicked = this.state.teamOneColors[0];
            // let teamOneColorObject = Color(teamOneColorPicked);
            // let teamTwoColorObject;

            // for (let color = 0; color < this.state.teamTwoColors.length; color++) {
            //     teamTwoColorObject = Color(this.state.teamTwoColors[color]);
            //     newContrast = Math.abs(teamOneColorObject.rgb().array()[0] - teamTwoColorObject.rgb().array()[0]);
            //     console.log("contrast between " + teamOneColorPicked + " and " + this.state.teamTwoColors[color] + " is " + newContrast);
            //     if (newContrast > contrast) {
            //         contrast = newContrast;
            //         teamTwoColorPicked = this.state.teamTwoColors[color];
            //     }

            // }

            this.state.teamsChosen.forEach(team => {
                //let teamColorObject = Color(team.colors[0]);
                teamColorsPicked.push(team.colors[0])

            });


            if (drawPossible) {
                teamColorsPicked.push('rgb(122,122,122)');
            }

            //console.log(teamOneColorPicked + " and " + teamTwoColorPicked + " were chosen as they provide the highest possible contrast of " + contrast);

        }


        makeContractEvent(eventBytes32Id, startTime, duration, contractTeams, false).then(
            function (result) {
                if (String(result).includes('User denied transaction signature')) {
                    message.warning("Metamask transaction denied! No event made.");
                } else {
                    return makeApiEvent(
                        authToken,
                        eventBytes32Id,
                        apiTeams,
                        drawPossible,
                        startTime,
                        duration,
                        makerBond,
                        UserStore.user._id,
                        false,
                        categoryId,
                        leagueId,
                        teamColorsPicked,
                        false,
                        "",
                        ""
                    ).then(function () {
                        return EventStore.queryEvents();
                    });

                    // return makeApiEvent(
                    //     authToken,
                    //     eventBytes32Id,
                    //     apiTeams,
                    //     drawPossible,
                    //     startTime,
                    //     duration,
                    //     makerBond,
                    //     UserStore.user._id,
                    //     false,
                    //     categoryId,
                    //     leagueId,
                    //     teamOneColorPicked,
                    //     teamTwoColorPicked,
                    //     false,
                    //     "",
                    //     ""
                    // ).then(function () {
                    //     return EventStore.queryEvents();
                    // });
                }
            });





    }

    renderTeamMenu() {
        let menuList = []
        let self = this;

        this.state.teams.forEach(function (team) {
            //console.log("leagueId: " + self.state.league+ "   team.league: " + team.league);
            if (self.state.leagueId == team.league)
                menuList.push(<Menu.Item key={team._id}>
                    <a target="_blank" rel="noopener noreferrer">{team.name}</a>
                </Menu.Item>);
        });

        return menuList;
    }

    renderTeamSelect() {
        let menuList = []
        let self = this;

        this.state.teams.forEach(function (team) {
            //console.log("leagueId: " + self.state.league+ "   team.league: " + team.league);
            if (self.state.leagueId == team.league)
                menuList.push(<Option key={team._id} value={team._id}>
                    {team.name}
                </Option>);
        });

        return menuList;

    }

    renderCategoryMenu() {
        let menuList = []

        this.state.categories.forEach(function (category) {
            menuList.push(<Menu.Item key={category._id}>
                <a target="_blank" rel="noopener noreferrer">{category.title}</a>
            </Menu.Item>);
        });

        return menuList;
    }


    renderLeagueMenu() {
        let menuList = []

        this.state.leagues.forEach(function (league) {
            menuList.push(<Menu.Item key={league._id}>
                <a target="_blank" rel="noopener noreferrer">{league.title}</a>
            </Menu.Item>);
        });

        return menuList;
    }



    onTeamOneClick(key) {

        let self = this;
        this.state.teams.forEach(function (team) {
            if (team._id == key) {
                self.setState({
                    teamOneId: team._id,
                    teamOneBytes32Id: team.bytes32Id,
                    teamOneName: team.name,
                    teamOneLogoUrl: team.logoUrl,
                    teamOneColors: team.colors
                });
            }
        });
    }

    onTeamTwoClick(key) {
        let self = this;
        this.state.teams.forEach(function (team) {
            if (team._id == key) {
                self.setState({
                    teamTwoId: team._id,
                    teamTwoBytes32Id: team.bytes32Id,
                    teamTwoName: team.name,
                    teamTwoLogoUrl: team.logoUrl,
                    teamTwoColors: team.colors
                });
            }
        });
    }

    onCategoryClick(key) {
        let self = this;
        this.state.categories.forEach(function (category) {
            if (category._id == key.key) {
                self.setState({
                    categoryName: category.title,
                    category: category._id
                });
            }
        });

    }

    onLeagueClick(key) {
        let self = this;
        this.state.leagues.forEach(function (league) {
            console.log("league._id :  " + league._id + "   key.key : " + key.key);
            if (league._id == key.key) {
                self.setState({
                    leagueName: league.title,
                    leagueId: league._id
                });
            }
        });

    }

    onDurationChange(value) {
        this.setState({ chosenDuration: value });
    }

    onDrawPossibleChange(event) {


        this.setState({ drawPossible: event.target.checked });
        message.info(event.target.checked ? 'A draw is possible' : 'A draw is NOT possible');
    }

    onFormChange(checked) {
        this.setState({ eSports: checked });
    }

    handleDateChange(moment, dateString) {
        let date = (moment ? moment.toDate() : null);
        //this.setState({ startDate: date });

        if (date != null) {
            this.setState({ officialStart: date.getTime() / 1000 });
            console.log("official start: " + this.state.officialStart);
        }
    }


    handleTeamsChange = (idx) => (e) => {
        const newTeams = this.state.teamsChosen.map((team, sidx) => {
            if (idx !== sidx) return team;
            return { ...team, team: e.target.value };
        });

        this.setState({ teamsChosen: newTeams });
    }


    onTeamClick(key, teamId) {

        let self = this;

        this.state.teams.forEach(function (team) {
            if (team._id == teamId) {
                let newTeamsChosen = self.state.teamsChosen;
                newTeamsChosen[key] = team;
                self.setState({
                    teamsChosen: newTeamsChosen
                });
            }
        });
    }

    handleAddTeam = () => {
        console.log("chosenteams: " + JSON.stringify(this.state.teamsChosen));
        this.setState({
            teamsChosen: this.state.teamsChosen.concat([{ team: '' }])
        });
    }

    handleRemoveTeam = (idx) => () => {
        console.log("removing team" + idx);
        this.setState({
            teamsChosen: this.state.teamsChosen.filter((s, sidx) => idx !== sidx)
        });
    }

    render() {
        return (
            <div className="admin-make-event">
                {/* <Switch checkedChildren="E-SPORTS" unCheckedChildren="SPORTS" onChange={this.onFormChange} /> */}
                {(this.state.eSports ?
                    <div>
                        <h2>Pick Teams</h2></div> :
                    <div>
                        <h2>Category Name</h2>
                        <Dropdown overlay={<Menu onClick={this.onCategoryClick}>{this.renderCategoryMenu()}</Menu>}>
                            <a className="ant-dropdown-link" href="#">
                                Choose a Category <Icon type="down" />
                            </a>
                        </Dropdown>
                        <p>{this.state.categoryName}</p>

                        <h2>League Name</h2>
                        <Dropdown overlay={<Menu onClick={this.onLeagueClick}>{this.renderLeagueMenu()}</Menu>}>
                            <a className="ant-dropdown-link" href="#">
                                Choose a League <Icon type="down" />
                            </a>
                        </Dropdown>
                        <p>{this.state.leagueName}</p>



                        {/* <h2>Pick Teams</h2>
                    

                        <Select theme="dark" placeholder="Choose team 1" style={{ width: 320 }} dropdownStyle={{ width: 320 }} onChange={this.onTeamOneClick}>
                            {this.renderTeamSelect()}
                        </Select>
                        <br />
                        <img height="52" width="92" src={this.state.teamOneLogoUrl} />
                        <span>{this.state.teamOneName}</span>
                        <br />
                        <br />
                   

                        <Select theme="dark" placeholder="Choose team 2" style={{ width: 320 }} dropdownStyle={{ width: 320 }} onChange={this.onTeamTwoClick}>
                            {this.renderTeamSelect()}
                        </Select>
                        <br />
                        <img height="52" width="92" src={this.state.teamTwoLogoUrl} />
                        <span>{this.state.teamTwoName}</span>
                        <br />
                        <br /> */}
                        <div className="admin-form-field">
                            <div className="admin-form-field-title">Choose Teams: </div>
                            {this.state.teamsChosen.map((team, idx) => (
                                <div className="PicUrl" key={idx}>
                                    <Select theme="dark" placeholder={"Choose team " + (idx + 1)} style={{ width: 320 }} dropdownStyle={{ width: 320 }} onChange={this.onTeamClick.bind(this, idx)}>
                                        {this.renderTeamSelect()}
                                    </Select>
                                    {/* <button className="custom-btn-primary" type="button" onClick={this.handleRemoveTeam(idx)}>-</button> */}
                                    {this.state.teamsChosen.length == (idx + 1) ?
                                        <button className="custom-btn-primary" type="button" onClick={this.handleAddTeam.bind(this)}>Add Field</button>
                                        :
                                        null
                                    }
                                </div>
                            ))}
                        </div>


                        <br />
                        <h2>Start Date and Time</h2>
                        <DatePicker showTime onChange={this.handleDateChange} />
                        {/* <TimePicker onChange={this.handleTimeChange}/> */}
                        <p>Start time is: {new Date(this.state.officialStart * 1000).toDateString()} {new Date(this.state.officialStart * 1000).toLocaleTimeString()} in your local time zone</p>
                        <br />
                        <h2>Duration (seconds)</h2>
                        <InputNumber onChange={this.onDurationChange} />
                        <p>{this.state.chosenDuration}</p>
                        <br />
                        <h2>Maker Bond (default for now)</h2>
                        <p>{this.state.makerBond}</p>


                        <br />
                        <br />
                        <h2>Draw Possible</h2>
                        <Checkbox onChange={this.onDrawPossibleChange} />
                        <br />
                        <br />
                        <button className="custom-btn-primary" onClick={() => this.onClick()}>Create new Event</button>
                    </div>)}
            </div>);
    }
}
export default MakeEvent;


// WEBPACK FOOTER //
// ./src/components/appComponents/admin/MakeEvent.js